import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoeListComponent } from './coe-list/coe-list.component';
import { CoeCreateComponent } from './coe-create/coe-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: CoeListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: CoeCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'coe-create/:id',
        component: CoeCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoeRoutingModule { }
